import { lazy } from 'react'

export const PreparingFlowVariant1 = lazy(
  () => import('./PreparingFlowVariant1'),
)
export const PreparingFlowVariant2 = lazy(
  () => import('./PreparingFlowVariant2'),
)
